<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">Lista de rechazos</h1>
        </b-col>
      </b-row>
      <v-server-table :url="url" :columns="columns" :options="options" :theme="theme" ref="table" id="dataTable">
        <template #actions="row">
          <modal-detalle-rechazo :id="row.row.id" :item="row.row"></modal-detalle-rechazo>
          <a href="javascript:;" @click.prevent="downloadWithAxios(row.row.id, row.row.id)">
            <i class="fa fa-lg fa-file-pdf-o"></i>
          </a>
          <email-modal :item-id="row.row.id" :item-data="row.row" />
          <a href="javascript:;" @click.prevent="confirmDelete(row.row)">
            <i class="fa fa-lg fa-trash text-danger pl-1"></i>
          </a>
        </template>
        <template slot="afterFilter">
          <tr class="VueTables__no-results">
            <b-button @click.prevent="resetFilters">Limpiar filtro</b-button>
            <download-excel
              class="btn"
              :fetch="fetchData"
              :fields="json_fields"
              worksheet="Rechazos"
              :name="name"
              :before-generate="startDownload"
              :before-finish="finishDownload"
            >
              <b-button>Descargar</b-button>
            </download-excel>
          </tr>
          <tr v-if="loading" class="VueTables__no-results">
            <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner"></b-spinner>
          </tr>
        </template>
      </v-server-table>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import tableTexts from "../../lang/tableTexts";
import EmailModal from "./EmailModal";
import ModalDetalleRechazo from "./ModalDetalleRechazo";

numeral.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "Rechazos",
  components: {
    ServerTable,
    EmailModal,
    ModalDetalleRechazo
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
      this.ready = true;
    });

    moment.locale("es");
  },
  data() {
    return {
      ready: false,
      loading: true,
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        id: "id",
        Fecha: "date",
        Guías: "waybills",
        Productor: "grower",
        Pallets: "pallets",
        Variedades: "varieties",
        Recip: "container",
        Kilos: "kilograms",
        Cantidad: "quantity"
      },
      columns: [
        "id",
        "date",
        "waybills",
        "grower",
        "pallets",
        "varieties",
        "container",
        "kilograms",
        "quantity",
        "actions"
      ],
      theme: "bootstrap4",
      template: "default",
      options: {
        // skin: "table table-sm table-hover table-striped  table-bordered border-0 table-fixed",
        debounce: 800,
        // skin: "table table-sm table-hover border-0",
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        rowAttributesCallback: function (row) {
          const date = moment(row.delivery_date).format("DD-MM-YYYY");
        },
        texts: tableTexts,
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["id", "date", "waybills", "grower", "pallets", "varieties", "container"],
        listColumns: {},
        headings: {
          id: "Id",
          date: "Fecha",
          waybills: "Guías",
          grower: "Productor",
          pallets: "Lotes",
          varieties: "Variedades",
          container: "Recip",
          kilograms: "Kilos",
          quantity: "Cantidad",
          actions: ""
        },
        columnsClasses: {
          id: "font-weight-bold",
          actions: "text-center"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      }
    };
  },
  watch: {
    url(val, oldVal) {
      this.$refs.table.refresh();
    }
  },
  computed: {
    name() {
      return "Rechazos " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    url() {
      return "/api/v1/bluefields/rechazo/?omit=defects,observations";
    }
  },
  methods: {
    confirmDelete(item) {
      this.$swal
        .fire({
          title: "¿Estás seguro?",
          text: "¡No podrás revertir esto! Además, los pallets asociados a este rechazo ya no estarán rechazados.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "lightgrey",
          confirmButtonText: "¡Sí, bórralo!"
        })
        .then((result) => {
          if (result.value) {
            this.deleteRechazo(item);
          }
        });
    },
    deleteRechazo(item) {
      console.log(item);
      this.$axios.delete("/api/v1/bluefields/rechazo/" + item.id + "/").then((response) => {
        this.$swal("¡Eliminado!", "El rechazo ha sido eliminado.", "success");
        this.$refs.table.refresh();
      });
    },
    sumColumn(column) {
      let total = 0;
      const data = this.$refs.table;
      if (data) {
        total += data.data.reduce((acc, item) => acc + parseFloat(item[column]), 0);
      }
      return total;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },
    refreshTable() {
      this.$refs.table.refresh();
    },
    async fetchData() {
      const response = await this.$axios.get(this.url + "&no_page");
      return response.data;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    },
    forceFileDownload(response, a) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Rechazo #" + a + ".pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    downloadWithAxios(a, b) {
      this.$axios({
        method: "get",
        url: `/api/v1/bluefields/rechazo/${a}/pdf/`,
        responseType: "arraybuffer"
      })
        .then((response) => {
          this.forceFileDownload(response, b);
          this.$bvToast.toast("Rechazo #" + b + " descargado", {
            title: "Descarga exitosa",
            variant: "success",
            solid: true
          });
        })
        .catch((error) => {
          this.$bvToast.toast("Rechazo #" + b + " no descargado", {
            title: "Descarga fallida",
            variant: "danger",
            solid: true
          });
          console.log(error);
        });
    },
    emailModal(obj) {
      this.$axios({
        method: "get",
        url: "/reports/arrival_emails/" + obj.company
      })
        .then((res) => {
          this.$bvToast.toast("Emails cargados", {
            title: "Carga exitosa",
            variant: "success",
            solid: true
          });
          this.to = res.data.emails.to.join();
          this.cc = res.data.emails.cc.join();
          this.bcc = res.data.emails.bcc.join();
        })
        .catch((error) => {
          this.$bvToast.toast("Emails no cargados", {
            title: "Carga fallida",
            variant: "danger",
            solid: true
          });
          console.log(error);
        });
      this.waybill_id = obj.id;
      this.subject = "Notificación de Rechazo" + obj.id;
      this.$bvModal.show("email-modal");
    }
  }
};
</script>

<style>
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }
  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
